<!-- <div class="word_plugin_body">
    <div class="word_plugin_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="ms_word_section_img">
                        <img src="assets/images/ms-word-img.png" alt="grammar-checker-cloud">
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="ms_word_section_text">
                        <h2>Trinka Browser Plug-in</h2>
                        <p>The Trinka Browser extension corrects and enhances your posts and messages in your favorite websites in real time! Write securely and successfully on the go!</p>
                        <div class="buttons_optinos">
                            <a class="plansButtons" id="GetStartedButtons" style="margin: 0 10px 0 0; padding: 0;" href="" target="_blank">Add to Chrome</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ms_process_sections">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="process_line first_chalid_section">
                            <div class="process_inner_section">
                                <img src="assets/images/Download.png" alt="trinka-cloud-login">
                            </div>
                            <div class="process_heading_title">
                                <h3>Download Chrome Extension</h3>
                            </div>
                        </div>
                    </div>
    
                    <div class="col-md-4">
                        <div class="process_line">
                            <div class="process_inner_section">
                                <img src="assets/images/Import.png" alt="type-import-grammar-check">
                            </div>
                            <div class="process_heading_title">
                                <h3>Allow permission to Add</h3>
                            </div>
                        </div>
                    </div>
    
                    <div class="col-md-4">
                        <div class="process_line last_chalid_scetion">
                            <div class="process_inner_section">
                                <img src="assets/images/ImproveYourWriting.png" alt="writing-improved-grammar">
                            </div>
                            <div class="process_heading_title">
                                <h3>Start Writing</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    <div class="better_writing_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Key Features of Trinka Browser Plug-in</h2>
                    <p>Trinka is available as an extension for Google Chrome browser to help you write better anywhere, anytime. Get corrections and suggestions in real-time. Even beter, it automatically check all your changes so you don't miss anything.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <div class="writing_bullet_points">
                        <img src="assets/images/AutoFileEdit_AutoFileEdit_02 1.svg" alt="">
                        <h3>Real-Time Editing</h3>
                        <p>No need to wait for the editor to suggest corrections. Trinka makes correction as you write.</p>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6">
                    <div class="writing_bullet_points">
                        <img src="assets/images/Icon_Style.svg" alt="">
                        <h3>Style Guide Preferences</h3>
                        <p>Tailor the grammar & word choice of your manuscript to comply with popular academic style guides (AMA 11th, AGU 2017).</p>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6">
                    <div class="writing_bullet_points">
                        <img src="assets/images/Icon_Document_Type.svg" alt="">
                        <h3>Subject Area & Document Type</h3>
                        <p>Customize Trinka to provide you the most relevant suggestions based on your subject area and type of manuscript.</p>
                    </div>
                </div>

                 <div class="col-md-4 col-sm-6">
                    <div class="writing_bullet_points">
                        <img src="assets/images/Icon_Style.svg" alt="">
                        <h3>Add to Dictionary</h3>
                        <p>Add your own words to "My Dictionary" and Trinka will not flag them as spelling errors in your future writing.</p>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="writing_bullet_points">
                        <img src="assets/images/Icon_Document_Type.svg" alt="">
                        <h3>Word Count Reduction</h3>
                        <p>Trinka makes wordy phrases concise to make your writing impactful and comply with journal guidelines.</p>
                    </div>
                </div>

                
                <div class="col-md-4 col-sm-6">
                    <div class="writing_bullet_points">
                        <img src="assets/images/AutoFileEdit_AutoFileEdit_02 1.svg" alt="">
                        <h3>Data Security</h3>
                        <p>Whatever you type is securly trasmitted and analyzed. Your data is never saved with us.</p>
                    </div>
                </div>
                

            </div>
        </div>
    </div>

    <div class="online_avaiable_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="avaiable_text">
                        <h2>Use Trinka in Other Apps </h2>
                        <p>Cloud, MS Word Plug-in,  Browser Plug-in 
                            TrinkaJS integration for your custom editors
                            Enterprise (API & On-Premise)</p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="avaiable_get_started" id="ComingSoonButtons">
                        <div class="icons" style="margin: 0 10px 0 0;">
                            <img src="assets/images/download_trinka_icon.png" alt="download-trinka-cloud-grammar-check">
                        </div>
                        <div class="get_started_text">
                            <h3>Coming soon !</h3>
                            <p>FREE Microsoft Word plug-in</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6" id="safariBrowser">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka浏览器插件</h1>
                        <p>Trinka浏览器扩展程序可以实时纠正并提升您在喜欢的网站上的创作，安全地助您成地地写作！</p>
                    </div>

                    <button title="即将推出 Safari">
                        <img src="assets/images/safari_logo.png" alt="">
                        即将推出</button>
                <div class="downloadForSafari">
                    <h2>下载:</h2>
                    <ul>
                        <li>
                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" title="下载 Chrome">
                                <img src="assets/images/NewChromeFicon.svg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" title="下载 Firefox">
                                <img src="assets/images/NewFirefoxFicon.svg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" title="下载 Edge">
                                <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="">
                            </a>
                        </li>
                    </ul>
                </div>

                </div>
                <div class="col-lg-6" id="BrowserGoogleChromeSection">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka浏览器插件</h1>
                        <p>Trinka浏览器扩展程序可以实时纠正并提升您在喜欢的网站上的创作，安全地助您成地地写作！</p>

                        <div class="browserPluginButton">
                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                class="buttonGoogleChrome" id="BrowserChromeButton">
                                <b>
                                    <img src="assets/images/NewChromeIcon.svg" alt="">
                                </b>
                                安装谷歌插件
                            </a>
                        </div>
                        <br />
                        <div class="commingSoonSeciton">
                            <p class="FirefoxAvalibale">
                                <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                    <img style="width: 32px;" src="assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox"> 安装火狐插件
                                </a>
                            </p>
                            <p class="SafariComingSoon EdgeBrowserPlugin">
                                <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                    <img style="width: 30px;" src="assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Chrome"> 安装Edge插件
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6" id="BrowserFirefoxSection">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka浏览器插件</h1>
                        <p>Trinka浏览器扩展程序可以实时纠正和增强您在喜欢的网站中的帖子和消息！ 助您一路安全成功地写作！</p>
                        <div class="browserPluginButton">
                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton">
                                <b>
                                    <img src="assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>另有适用版本</i>
                            </a>
                        </div>
                        <br />
                        <div class="commingSoonSeciton">
                            <p class="FirefoxAvalibale">
                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                    <img style="width: 32px;" src="assets/images/NewChromeIcon.svg" alt="Grammar checker for Firefox"> 安装谷歌插件
                                </a>
                            </p>
                            <p class="SafariComingSoon EdgeBrowserPlugin">
                                <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                    <img style="width: 30px;" src="assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Chrome"> 安装边缘插件
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6" id="BrowserEdgeBrowserSection">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka浏览器插件</h1>
                        <p>Trinka浏览器扩展程序可以实时纠正和增强您在喜欢的网站中的帖子和消息！ 助您一路安全成功地写作！</p>
                        <div class="browserPluginButton">

                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                <b>
                                    <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>安装边缘插件</i>
                            </a>
                        </div>
                        <br />
                        <div class="commingSoonSeciton">
                            <p class="FirefoxAvalibale">
                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                    <img style="width: 32px;" src="assets/images/NewChromeIcon.svg" alt="Grammar checker for Firefox"> 安装谷歌插件
                                </a>
                            </p>
                            <p class="SafariComingSoon EdgeBrowserPlugin">
                                <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                    <img style="width: 30px;" src="assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Chrome"> 另有适用版本
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/BrowserPlugin_banner.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <h2>工作原理</h2>
                        <div class="HeadingSubLine"></div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/TypeOrImportFile_icon.png" alt="" style="width: 36px; height: 45px;">
                                </div>
                                <h3>安装浏览器扩<br />展功能</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/RegisterAndLogin.png" alt="" style="    width: 46px;  height: 45px;">
                                </div>
                                <h3>登录/注册</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/improveYourWriting_icon.png" alt="" style="    width: 36px;  height: 46px;">
                                </div>
                                <h3>开始写作</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="brandlogo_heading">
                        <h2>Trinka 的插件适用于：</h2>
                    </div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/google-docs.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/authorea.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/researchgate.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/medium.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/writing-cooprative.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/evernote.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/notion.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/linked-in.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/twitter.png" alt="">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/gmail.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="viewfullList">
                        <!-- <a routerLink="/brand-list">View Full List</a> -->
                        还可用于更多不同平台
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Trinka浏览器插件的主要功能</h2>
                        <div class="HeadingSubLine"></div>
                        <p>为您喜爱的浏览器安装Trinka插件，帮助您随时随地写得更好，以及实时获取修订和建议。更棒的是，它也会自动检查所有更改，因此不会放过任何错误。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/realTimeEditing_icon.svg" alt="">
                        <h3>实时编辑</h3>
                        <p>Trinka会在您写作时随时修订，无需等待编辑的修订建议。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/AddtoDictionary.svg" alt="">
                        <h3>添加到词典</h3>
                        <p>将自己的单词添加到“我的词典”中，这样Trinka就不会在将来的写作中将其标记为拼写错误。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/DataSecurityIcon.svg" alt="">
                        <h3>数据安全</h3>
                        <p>您输入的任何内容都会被安全地传输和分析，我们决不会保留您的数据。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="writeToolboxs_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="writerBox_heading">
                        <div class="howItWorkHeading">
                            <h2>Trinka 浏览器插件：在哪工作都任您行</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">

                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>在Google Docs 上的语法更正</h2>
                            <p>您想在 Google Docs上更好地写作，并轻松纠正所有语法错误吗？</p>
                            <p>添加 Trinka的浏览器扩展程序，并在 Google Docs上获得实时语法和拼写更正以及语言增强功能。</p>
                            <!-- <a href="#">
                                Read More
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="assets/images/google-doc-ss.jpg" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections writeToolbox_inner_sections_even" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');background-position: right center;">
            <div class="container">
                <!-- <div class="row">
                            <div class="col-sm-12">
                                <div class="writerBox_heading">
                                    <h2>How to write better on Authorea?</h2>
                                    <div class="HeadingSubLine"></div>
                                </div>
                            </div>
                        </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="assets/images/authorea-ss.jpg" alt="" class="img-fluid">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>如何在 Authorea上写得更好？</h2>
                            <p>您是否使用Authorea来满足您的写作需求？如果是，那么提高写作质量的语法校正工具是必不可少的！</p>
                            <p>使用Trinka的浏览器插件，实时修复语法错误，并在 Authorea 上写得更好。</p>
                            <!-- <a href="#">
                                Read More
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="writerBox_heading">
                                        <h2>Correct your writing on Evernote</h2>
                                        <div class="HeadingSubLine"></div>
                                    </div>
                                </div>
                            </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>修正你在 Evernote上的写作</h2>
                            <p>提高你在Evernote上的写作质量。Trinka是我们的人工智能写作工具，可以实时纠正语法并改进语言。</p>
                            <p>Trinka的浏览器扩展与Evernote完全兼容，易于使用。您可以毫不费力地查看和编辑您的作品。</p>
                            <!-- <a href="#">
                                    Read More
                                    <img src="assets/images/ReadMoreArrow.png" alt="">
                                </a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="assets/images/evernote-ss.jpg" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections writeToolbox_inner_sections_even" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');background-position: right center;">
            <div class="container">
                <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="writerBox_heading">
                                        <h2>Write better on Medium with Trinka</h2>
                                        <div class="HeadingSubLine"></div>
                                    </div>
                                </div>
                            </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="assets/images/medium-ss.jpg" alt="" class="img-fluid">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>提升在Medium上的写作</h2>
                            <p>你在 Medium 上写博客吗？不要错过 Trinka 免费浏览器插件提供的编辑功能。</p>
                            <p>Trinka会在语法、语调、标点符号、句子结构等方面纠正您的写作，并提高整体写作质量，这将给Medium上的读者留下深刻印象。</p>
                            <!-- <a href="#">
                                    Read More
                                    <img src="assets/images/ReadMoreArrow.png" alt="">
                                </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <div class="browser_plugin_cta">
        <div class="container">
            <div class="row">
                <div class="col-lg-12" id="BrowserGoogleChromeSection_cta">
                    <div class="trinka_cloud_banner_text">

                        <div class="browserPluginButton">
                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                class="buttonGoogleChrome" id="BrowserChromeButton">
                                <b>
                                    <img src="assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome">
                                </b>
                                <i>
                                    安装谷歌插件</i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserFirefoxSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">
                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton_cta">
                                <b>
                                    <img src="assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>安装火狐插件 </i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserEdgeBrowserSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">

                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                <b>
                                    <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>安装Edge插件</i>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他应用程序中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>

                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="/trinkacloud">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold; font-size: 18px">Trinka</span>云</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/wordplugin">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Others_App_MSWord.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold;font-size: 18px;">Word</span>
                                                <br />插件</h3>

                                        </div>
                                    </a>
                                </li>
                                <!-- <li>
                                    <div class="app_name_content" routerLink="/browser-plugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/other_Apps_browser.svg" alt="">
                                        <h3>浏览器插件</h3>
                                    </div>
                                </li> -->
                                <li>
                                    <a href="/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_Apps_enterprise.svg" alt="">
                                            <h3 style="margin: 0 0 -2px 0;">企业</h3>
                                            <span class="OpenSansFonts" style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>